module.exports = __webpack_public_path__ + "img/milk.be5030ca.webp";